<template>
  <b-modal id="chatroom-url-modal" footer-class="d-flex justify-content-end">
    <template #modal-header="{ close }">
      <h5 class="m-0 align-self-center">{{ title }}</h5>
      <b-button size="sm" variant="link" class="text-dark" @click="close()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 512"
          style="height: 20px"
        >
          <path
            d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
          />
        </svg>
      </b-button>
    </template>
    
    <h5 class="mb-2">{{ label }}</h5>
    <b-textarea
      :id="'chatroom-url'"
      v-b-tooltip.click="'已複製'"
      v-model="url"
      @click="copyUrl('#chatroom-url')"
    ></b-textarea>
    <div class="d-flex flex-column align-items-center mt-3">
      <vue-qr :text="url" ref="qrcode"></vue-qr>
      <b-button
        variant="primary"
        class="center-button mt-2"
        @click="downloadQRCode($refs.qrcode, title)"
      >
        下載QRCode
      </b-button>
    </div>

    <template #modal-footer>
      <b-button variant="danger" @click="$bvModal.hide('chatroom-url-modal')">
        關閉
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import generateLiffUrl from "@/mixins/Dashboard/liffUrlHelper";

export default {
  name: "ChatroomUrlModal",
  mixins: [generateLiffUrl],
  data() {
    return {
      title: "",
      label: "",
      url: "",
    };
  },
  components: {
    VueQr: () => import("vue-qr"),
  },
  methods: {
    showMobileChatroomLink() {
      this.title = "手機版對話連結";
      this.label = "手機版對話連結網址";
      this.url = `${this.generateLiffUrl("chatrooms/")}?as_staff=1`;
      this.$bvModal.show("chatroom-url-modal");
    },
    showSalesBindLink() {
      this.title = "業務啟用連結";
      this.label = "業務啟用連結網址";
      this.url = this.generateLiffUrl("sales/staff/active");
      this.$bvModal.show("chatroom-url-modal");
    },
    copyUrl(id) {
      const inputText = document.querySelector(id);
      inputText.select();
      document.execCommand("copy");
    },
    downloadQRCode(ref, filename) {
      const base64QRCodeImage = ref.$el?.src;
      if (base64QRCodeImage) {
        const temporaryDownloadLink = document.createElement("a");
        temporaryDownloadLink.href = base64QRCodeImage;
        temporaryDownloadLink.download = filename
          ? `${filename}.png`
          : "qrcode.png";
        temporaryDownloadLink.style.display = "none";
        document.body.appendChild(temporaryDownloadLink);
        temporaryDownloadLink.click();
      }
    },
  },
};
</script>
